import React, { useEffect, useRef, useState } from 'react'
import styles from './Header.module.scss'
import { Navbar } from 'react-bootstrap'
import { BRAND_CONFIG } from '../../branding/brandConfig'

const STEP_LABELS = {
  load: 'Data',
  map: 'Chart',
  style: 'Style',
  export: 'Export',
}

export default function Header({
  sessionStatusLabel = '',
  onClearSavedSession,
  onLogoClick,
  currentStep = null,
}) {
  const [menuOpen, setMenuOpen] = useState(false)
  const menuRef = useRef(null)

  useEffect(() => {
    if (!menuOpen) return
    function handleOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false)
      }
    }
    document.addEventListener('mousedown', handleOutside)
    document.addEventListener('touchstart', handleOutside)
    return () => {
      document.removeEventListener('mousedown', handleOutside)
      document.removeEventListener('touchstart', handleOutside)
    }
  }, [menuOpen])

  const hasSessionInfo = sessionStatusLabel || onClearSavedSession

  return (
    <Navbar bg="white" expand="lg" sticky="top" className={styles.navbar}>
      <Navbar.Brand
        href="/"
        onClick={onLogoClick ? (e) => { e.preventDefault(); onLogoClick() } : undefined}
      >
        <b>{BRAND_CONFIG.wordmark.lead}</b>
        <span className="text-primary">{BRAND_CONFIG.wordmark.accent}</span>
      </Navbar.Brand>

      {currentStep && STEP_LABELS[currentStep] && (
        <span className={styles.stepLabel}>
          {STEP_LABELS[currentStep]}
        </span>
      )}

      <div className={styles.headerRight} ref={menuRef}>
        {hasSessionInfo && (
          <div className={styles.menuWrap}>
            <button
              type="button"
              className={styles.hamburger}
              onClick={() => setMenuOpen((o) => !o)}
              aria-label="Menu"
              aria-expanded={menuOpen}
            >
              <span className={styles.hamburgerBar} />
              <span className={styles.hamburgerBar} />
              <span className={styles.hamburgerBar} />
            </button>

            {menuOpen && (
              <div className={styles.dropdown}>
                {sessionStatusLabel && (
                  <div className={styles.dropdownStatus}>
                    <span className={styles.sessionDot} aria-hidden="true" />
                    <span>{sessionStatusLabel}</span>
                  </div>
                )}
                {onClearSavedSession && (
                  <button
                    type="button"
                    className={styles.dropdownItem}
                    onClick={() => { onClearSavedSession(); setMenuOpen(false) }}
                  >
                    Clear saved session
                  </button>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </Navbar>
  )
}
